import React, { useState, useEffect, useRef, useMemo } from "react";
import Loading from "../../../Student/Reusablecomponents/Loading";

import { Row, Col } from "react-bootstrap";
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import {
  DDSystem,
  DDStream,
  DDSubSystem,
  DDTopic,
  DDSubTopic,
  DDLearningOC,
} from "../../../ReusableComponents/MultiselectScienceQBDropdowns";
import { DDSubLearningOC } from "../../../ReusableComponents/MultiselectQBDropdowns";
import {
  QuestionLevel,
  BloomTaxonomy,
} from "../../../ReusableComponents/QBDropdowns";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";

import Scenario from "../MathScenario/ScenarioList";
import DirectQuestions from "../MathsDirectQuestions/DirectQuestions";

import { FQData } from "../../../Redux/Reducers/QBAdmin/FilterQDeatails";

import notify from "../../../ReusableComponents/ToastifyAlerts";

import { useNavigate, useLocation } from "react-router-dom";

import Multiselect from "multiselect-react-dropdown";

const ScienceFilters = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const ChapterRef = useRef();
  const GradeRef = useRef();
  const StatusRef = useRef();
  const ScrollRef = useRef(null);

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const PNumber =
    PagnatioNumber?.Location === location.pathname &&
    PagnatioNumber?.PageNumber;
  const [CurrentPage, SetCurrentPage] = useState(PNumber || 1);

  const [Load, SetLoad] = useState(false);
  const RestoreFilters = JSON.parse(localStorage.getItem("FSelected"))?.Filters;
  const [Filters, SetFilters] = useState({
    Sytem: [],
    Stream:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Stream || [],
    SubSystem:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubSystem || [],
    Topic: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Topic || [],
    SubTopic:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubTopic || [],
    LOC: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.LOC || [],
    SubLOC:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubLOC || [],
    Chapter:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Chapter || [],
    Grade: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Grade || [],
    Status:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Status || [],
  });
  const [PreSelectedFilters, SetPreSelectedFilters] = useState({
    Chapter: [],
    Grade: [],
  });
  const [ChapterOptions, SetChapterOptions] = useState([]);
  const [GradeOptions, SetGradeOptions] = useState([]);
  const [QLevel, SetQLevel] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.QLevel || ""
  );
  const [BTaxonomy, SetBTaxonomy] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.BTaxonomy || ""
  );

  const [FiltersList, SetFiltersList] = useState();
  const [FilterScenarioList, SetFilterScenarioList] = useState();
  const [FilterQuestionList, SetFilterQuestionList] = useState();
  const [NSBased, SetNSBased] = useState(
    localStorage.getItem("FINQSNS") || "1"
  );

  const [FSQLParams, SetFSQLParams] = useState({
    Row: "",
    Rowindex: JSON.parse(localStorage.getItem("Rowindex"))?.SIndex || "",
  });

  const Tabcode = () => {
    localStorage.removeItem("Rowindex");
    switch (location.state?.Tab || "SCQ") {
      case "SCQ":
        return "SCQ";
      case "DQ":
        return "DQ";
      case "INQ":
        return "INQ";
    }
  };

  const StoreFilters = (e, r, Name) => {
     if (Name === "LOC") {
      const LOCValues = e.map((val) => val?.value).join(",");
      if (LOCValues?.length > 0) {
        GetCGMultiselect(LOCValues);
      } else {
        ChapterRef.current.resetSelectedValues();
        GradeRef.current.resetSelectedValues();
        SetChapterOptions([]);
        SetGradeOptions([]);
        SetPreSelectedFilters((prev) => ({ ...prev, Grade: [], Chapter: [] }))
        SetFilters((prev) => ({ ...prev, Grade: [], Chapter: [] }));
      }
    }
    if (Name === "Status") {
      if (Filters[Name].includes(r)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r] });
      }
    } else {
      if (Filters[Name].includes(r.value)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r.value),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r.value] });
      }
      // CLearvalueremove(Name);
    }
  };
  const CLearvalueremove = (Name) => {
    if (FiltersList) {
      // localStorage.removeItem("FSelected");
      SetChapterOptions([]);
      SetGradeOptions([]);
      SetPreSelectedFilters({ Chapter: [], Grade: [] });
      switch (Name) {
        case "Sytem":
          SetFilters({
            ...Filters,
            Stream: [],
            SubSystem: [],
            Topic: [],
            SubTopic: [],
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "Stream":
          SetFilters({
            ...Filters,
            SubSystem: [],
            Topic: [],
            SubTopic: [],
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "SubSystem":
          SetFilters({
            ...Filters,
            Topic: [],
            SubTopic: [],
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "Topic":
          SetFilters({
            ...Filters,
            SubTopic: [],
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "SubTopic":
          SetFilters({
            ...Filters,
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "LOC":
          SetFilters({ ...Filters, SubLOC: [], Chapter: [], Grade: [] });
          break;
      }
    }
  };

  const StoreStartValue = (e) => {
    SetFilters({ ...Filters, Sytem: e });
  };

  const GetCGMultiselect = async (LOC) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/ScienceQuestionBankByLO/GetScienceChapterAndGradeByLO?LO=${LOC}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        // ChapterRef.current.resetSelectedValues();
        // GradeRef.current.resetSelectedValues();
        const ChapterOp = [];
        const GradeOp = [];
        res.data.map((item) => {
          if (
            !ChapterOp.some((chapter) => chapter.value === item.chapterLovId)
          ) {
            ChapterOp.push({
              name: item.chapterName,
              value: item.chapterLovId,
            });
          }
          if (!GradeOp.some((grade) => grade.value === item.gradeLovId)) {
            GradeOp.push({ name: item.gradeName, value: item.gradeLovId });
          }
        });
        SetChapterOptions(ChapterOp);
        SetGradeOptions(GradeOp);
          SetPreSelectedFilters((prev) => ({
            ...prev,
            Chapter: ChapterOp,
          }));
          SetFilters((prev) => ({
            ...prev,
            Chapter:ChapterOp?.map((c) => (c.value)),
          }));
          SetPreSelectedFilters((prev) => ({
            ...prev,
            Grade: GradeOp,
          }));
          SetFilters((prev) => ({
            ...prev,
            Grade:GradeOp?.map((c) => (c.value))
          }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (!FiltersList && Filters?.Sytem?.length > 0) {
      GetFiltersList();
    }
  }, [NSBased, Filters?.Sytem]);

  const HandleSNS = (e) => {
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList();
    SetNSBased(e);
    localStorage.setItem("FINQSNS", e);
  };
  // Below is filter list
  const GetFiltersList = async () => {
    SetLoad((prev) => !prev);
    SetFilterScenarioList();
    SetFilterQuestionList();
    const data = {
      Filters: Filters,
      QLevel: QLevel,
      BTaxonomy: BTaxonomy,
    };
    localStorage.setItem("FSelected", JSON.stringify(data));

    if (Filters?.Sytem?.length > 0) {
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
            `/ScienceQuestionBankByLO/GetScienceQuestionBankByFilter?System=${
              Filters?.Sytem?.join(",") || 0
            }&Stream=${Filters?.Stream?.join(",") || 0}&SubSystem=${
              Filters?.SubSystem?.join(",") || 0
            }&TopicId=${Filters?.Topic?.join(",") || 0}&SubTopicId=${
              Filters?.SubTopic?.join(",") || 0
            }&LO=${Filters?.LOC?.join(",") || 0}&IsScenario=${
              Tabcode() === "INQ" ? NSBased : 0
            }
                &SubLO=${Filters?.SubLOC?.join(",") || 0}&ChapterId=${
              Filters?.Chapter?.join(",") || 0
            }&GradeId=${Filters?.Grade?.join(",") || 0}&QLevel=${
              QLevel || 0
            }&Blooms=${BTaxonomy || 0}&IsUsed=${
              Filters?.Status?.join(",") || 0
            }&QBCategoryType=${Tabcode()}`,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data[0]?.systemName) {
            SetFiltersList(res.data);
          } else {
            SetFiltersList(process.env.REACT_APP_NODATAFOUND);
          }
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      SetLoad((prev) => !prev);
      SetFiltersList();
      notify("Sytem is mandatory", "warning");
    }
  };

  const FiltersListColumns = [
    { name: "System", selector: "systemName", sortable: true },
    { name: "Stream", selector: "streamName", sortable: true },
    { name: "Sub-System", selector: "subSystemName", sortable: true },
    { name: "Topic", selector: "topicName", sortable: true },
    { name: "Sub Topic", selector: "subTopicName", sortable: true },
    { name: "Learning Outcome", selector: "loName", sortable: true },
    { name: "Sub Learning Outcome", selector: "subLOName", sortable: true },
    { name: "Chapter", selector: "chapterName", sortable: true },
    { name: "Grade", selector: "gradeName", sortable: true },
    {
      name: "Add/ View",
      sortable: true,
      cell: (row, Rindex) => (
        <div style={{ display: "flex", gap: "3px" }}>
          {Tabcode() !== "DQ" && NSBased !== "2" && (
            <>
              {" "}
              <div
                className="LinkStyles"
                onClick={() => HandleFilterSCenarioList(row, Rindex)}
              >
                Scenario ({row.sCount}){" "}
              </div>{" "}
              |
            </>
          )}
          <div
            className={(Tabcode() === "DQ" || NSBased === "2") && "LinkStyles"}
            onClick={() => HandleFilterQuestionList(row, Rindex)}
          >
            {" "}
            Question ({row.qCount}){" "}
          </div>{" "}
          |
          <div
            className="LinkStyles"
            onClick={() => {
              HandelRemidation(row, Rindex);
            }}
          >
            {" "}
            Remedition ({row.remediationCount})
          </div>
        </div>
      ),
    },
  ];
  // Above is filter list

  // Below are Scenario List
  const HandleFilterSCenarioList = (Row, Rindex) => {
    // StoreFilterValues();
    dispatch(FQData({ FQDetails: Row }));
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    if (Tabcode() === "SCQ") {
      FiltersScenarioList(Row, "SCQ");
    } else if (Tabcode() === "INQ" && NSBased === "1") {
      FiltersScenarioList(Row, "SCDISQ");
    }
  };

  const FiltersScenarioList = async (Row, QType) => {
    SetFilterScenarioList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/Scenario/GetScenarioByLOs?SubjectId=${items?.subjectId}&LOId=${Row.loid}&SubLOId=${Row.subLOId}&ChapterId=${Row.chapterId}&GradeId=${Row.gradeId}&QLevelId=${Row.qLevel}&BloomsId=${Row.bloomsId}&IsCloned=${Row.isCloned}&QBCategoryType=${QType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.scenarioID) {
          SetFilterScenarioList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 500);
        } else {
          SetFilterScenarioList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above are Scenario List

  // Below are Questions List
  const HandleFilterQuestionList = (Row, Rindex) => {
    if (Tabcode() === "DQ" || NSBased === "2") {
      SetFSQLParams({ Row: Row, Rowindex: Rindex });
      const SelectRow = {
        SIndex: Rindex,
        CPage: CurrentPage,
      };
      localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
      dispatch(FQData({ FQDetails: Row }));
      if (Tabcode() === "DQ") {
        FiltersQuestionList(Row, "NONSCQ");
      } else if (Tabcode() === "INQ" && NSBased === "2") {
        FiltersQuestionList(Row, "NONSCDISQ");
      }
    }
  };

  const FiltersQuestionList = async (Row, Qtype) => {
    SetFilterQuestionList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetQuestionsByLOs?SubjectId=${items?.subjectId}&TopicId=${Row.topicId}&SubTopicId=${Row.subTopicId}&LOId=${Row.loid}&SubLOId=${Row.subLOId}&ChapterId=${Row.chapterId}&GradeId=${Row.gradeId}&QLevelId=${Row.qLevel}&BloomsId=${Row.bloomsId}&IsCloned=0&QBCategoryType=${Qtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.questionID) {
          SetFilterQuestionList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 500);
        } else {
          SetFilterQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Above are Questions List

  // Below is Remidation List
  const HandelRemidation = (Row, Rindex) => {
    // StoreFilterValues();
    // SetFilters({ Topic: [], SubTopic: [], LOC: [], SubLOC: [], Chapter: [], Grade: [], Status: [], });
    // SetRContent(!RContent);
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    dispatch(FQData({ FQDetails: Row }));
    navigate("/QBAdmin/QuestionBank/Remidation", {
      state: { Tab: location.state?.Tab },
    });
  };
  // Above is Remidation List
  const ClearAllSTates = () => {
    localStorage.removeItem("FSelected");
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList(); /*SetSelectedRow();*/
    SetNSBased("1");
    /*SetINBFQList();*/ SetFSQLParams({ Row: "", Rowindex: "" });
    localStorage.removeItem("Rowindex");
    // if (!RContent) {
    ChapterRef?.current?.resetSelectedValues();
    GradeRef?.current?.resetSelectedValues();
    StatusRef?.current?.resetSelectedValues();
    // }
    SetFilters({
      Sytem: [],
      Stream: [],
      SubSystem: [],
      Topic: [],
      SubTopic: [],
      LOC: [],
      SubLOC: [],
      Chapter: [],
      Grade: [],
      Status: [],
    });
    SetPreSelectedFilters({ Chapter: [], Grade: [] });
    SetFiltersList();
    SetChapterOptions([]);
    SetGradeOptions([]);
    SetQLevel("");
    SetBTaxonomy();
  };
  useMemo(() => {
    if (FiltersList) {
      localStorage.removeItem("FSelected");
      ClearAllSTates();
    }
  }, [location.state.Tab]);

  useMemo(() => {
    // if (!JSON.parse(localStorage.getItem("Rowindex"))?.CPage) {
    if (CurrentPage != JSON.parse(localStorage.getItem("Rowindex"))?.CPage) {
      SetFSQLParams({ Row: "", Rowindex: "" });
      localStorage.removeItem("Rowindex");
      SetFilterScenarioList();
      SetFilterQuestionList();
    }
    // }, [CurrentPage,PNumber]);
  }, [CurrentPage]);
  return (
    <>
      {Tabcode() === "INQ" && (
        <div className="dflex JCCenter" style={{ gap: "15px" }}>
          {["1", "2"].map((Item) => (
            <div key={Item} className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                value={Item}
                name="NONSCENario"
                checked={NSBased === Item}
                onChange={(e) => HandleSNS(e.target.value)}
              />{" "}
              {Item === "1" ? "Scenario Based" : "Non Scenario Based"}
            </div>
          ))}
        </div>
      )}

      <div className=" Card container-fluid mt-2 mb-2">
        <Row>
          <Col>
            <DDSystem
              className="NCLDropdown"
              SubjectId={items?.subjectId}
              onChange={(e, r) => StoreFilters(e, r, "Sytem")}
              StoreOptions={(e) => StoreStartValue(e)}
              Selected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Sytem
              }
              Preselected={Filters?.Sytem?.length}
            />
          </Col>
          <Col>
            <DDStream
              className="NCLDropdown"
              Pid={Filters?.Sytem?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "Stream")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Stream
              }
              clear={(Name) => CLearvalueremove(Name)}
            />
          </Col>
          <Col>
            <DDSubSystem
              className="NCLDropdown"
              Pid={Filters?.Stream?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "SubSystem")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters
                  ?.SubSystem
              }
              clear={(Name) => CLearvalueremove(Name)}
            />{" "}
          </Col>
          <Col>
            <DDTopic
              className="NCLDropdown"
              Pid={Filters?.SubSystem?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "Topic")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Topic
              }
              clear={(Name) => CLearvalueremove(Name)}
            />
          </Col>

          <Col>
            {" "}
            <DDSubTopic
              className="NCLDropdown"
              Pid={Filters?.Topic?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "SubTopic")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubTopic
              }
              clear={(Name) => CLearvalueremove(Name)}
            />{" "}
          </Col>
        </Row>{" "}
        <Row>
          <Col>
            {" "}
            <DDLearningOC
              className="NCLDropdown"
              Pid={Filters?.SubTopic?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "LOC")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.LOC
              }
              clear={(Name) => CLearvalueremove(Name)}
            />
          </Col>
          <Col>
            {" "}
            <DDSubLearningOC
              className="NCLDropdown"
              SubjectId={items?.subjectId}
              Pid={Filters?.LOC?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "SubLOC")}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubLOC
              }
              clear={(Name) => CLearvalueremove(Name)}
            />
          </Col>

          <Col>
            {" "}
            <div className="DropdownHeaderNIMP">
              {" "}
              Chapter :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Chapter")}
                onSelect={(e, r) => StoreFilters(e, r, "Chapter")}
                style={{ searchBox: { minHeight: "15vh" } }}
                displayValue="name"
                placeholder=""
                options={ChapterOptions}
                ref={ChapterRef}
                showCheckbox
                avoidHighlightFirstOption="true"
                selectedValues={PreSelectedFilters?.Chapter}
              />
            </div>
          </Col>

          <Col>
            <div className="DropdownHeaderNIMP">
              {" "}
              Grade :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Grade")}
                onSelect={(e, r) => StoreFilters(e, r, "Grade")}
                style={{ searchBox: { minHeight: "15vh" } }}
                displayValue="name"
                placeholder=""
                options={GradeOptions}
                ref={GradeRef}
                showCheckbox
                avoidHighlightFirstOption="true"
                selectedValues={PreSelectedFilters?.Grade}
              />
            </div>
          </Col>
          <Col>
            <div className="DropdownHeaderNIMP">
              {" "}
              Status :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Status")}
                onSelect={(e, r) => StoreFilters(e, r, "Status")}
                style={{ searchBox: { minHeight: "15vh" } }}
                isObject={false}
                placeholder=""
                showCheckbox
                ref={StatusRef}
                options={["Used", "Unused", "Mapped", "Unmapped", "NA"]}
                selectedValues={Filters?.Status}
                avoidHighlightFirstOption="true"
                /*disablePreSelectedValues="true"*/
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <QuestionLevel
              className="NCLDropdown w-100"
              SubjectId={items?.subjectId}
              StoreValue={SetQLevel}
              SOption={QLevel}
              LovCategoryId={16}
              onChange={(e) => SetQLevel(e.length > 4 ? "" : e)}
              Displayname="Select Question Level"
              labelname={<div className="DropdownHeader">Question Level :</div>}
              LID={SelectLanguage}
            />
          </Col>
          <Col>
            {" "}
            <BloomTaxonomy
              className="NCLDropdown w-100"
              SubjectId={items?.subjectId}
              PId={QLevel}
              StoreValue={SetBTaxonomy}
              LovCategoryId={39}
              SOption={BTaxonomy}
              onChange={(e) => SetBTaxonomy(e)}
              labelname={
                <div className="DropdownHeader">Bloom's Taxonomy :</div>
              }
              LID={SelectLanguage}
            />
          </Col>
          <Col> </Col> <Col></Col> <Col> </Col>
        </Row>
        <div className="dflex gap-3 mt-2">
          <button
            className="Buttons CancleButton"
            onClick={() => ClearAllSTates()}
          >
            Clear
          </button>
          <button
            className="Buttons "
            onClick={() => {
              GetFiltersList();
              SetFSQLParams();
            }}
          >
            Go
          </button>
        </div>
      </div>

      {FiltersList && (
        <div className="Card" ref={ScrollRef}>
          {" "}
          <DataTable
            data={FiltersList}
            Selected={parseInt(FSQLParams?.Rowindex)}
            columns={FiltersListColumns}
            className="NCLDataTable"
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
            GetCurrentPage={SetCurrentPage}
            Selectedpage={JSON.parse(localStorage.getItem("Rowindex"))?.CPage}
          />{" "}
        </div>
      )}
    {(FilterScenarioList || FilterQuestionList) && (
        <div className="dflex alignitems mt-4">
         {items?.subjectName} &gt;{FQuestionDetails.topicName} &gt; {FQuestionDetails.subTopicName}{" "}
          &gt; <b className="text-success"> {FQuestionDetails.loName}</b>
        </div>
      )}
      {FilterScenarioList && <Scenario data={FilterScenarioList} />}

      {FilterQuestionList && (
        <DirectQuestions
          data={FilterQuestionList}
          Filtersfunction={() =>
            HandleFilterQuestionList(FSQLParams?.Row, FSQLParams?.Rowindex)
          }
        />
      )}

      {Load && <Loading />}
    </>
  );
};
export default ScienceFilters;